module.exports = __webpack_public_path__ + "static/media/Professor Login.e7c5f216.png";